import { ChangeDetectionStrategy, Component, input,  } from '@angular/core';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoComponent {
  height = input(53);
  width = input(222);
}
